// A team's last five games in letters on their colors (B-387), oldest on the
// left, as a football table's form column carries them.

import type { GameResult } from '@fsp/domain';

const WORD: Record<GameResult, string> = { W: 'won', L: 'lost', T: 'tied' };

/**
 * Marks, not controls: they sit inside the row, which is the one button
 * (UX-2), and one sentence reads them out. A result is its letter as well
 * as its color (UX-28).
 */
export function Form({ results }: { results: readonly GameResult[] }) {
  const last = results.slice(-5);
  if (last.length === 0) return <span />;
  return (
    <span
      className="fsp-st-form"
      role="img"
      aria-label={`Last ${last.length}: ${last.map((r) => WORD[r]).join(', ')}.`}
    >
      {last.map((r, i) => (
        <span key={i} className="fsp-st-form-mark" data-result={r}>
          {r}
        </span>
      ))}
    </span>
  );
}
